import { catchError, map, Observable, of } from 'rxjs';
import { Component, ElementRef, inject, OnInit, ViewChild, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import { HeadService } from '../../services/head.service';

import { MenuCustomerService } from './model/customer-service.model';

@Component({
  selector: 'app-megamenu-customer-service',
  imports: [CommonModule, RouterLink],
  templateUrl: './megamenu-customer-service.html',
  styleUrl: './megamenu-customer-service.scss',
})
export class MegamenuCustomerService implements OnInit {
  private headService = inject(HeadService);

  public categoriesService$!: Observable<MenuCustomerService[]>;
  public isMobile = false;
  @ViewChild('categories') categories!: ElementRef;
  @ViewChild('megamenuService') megamenu!: ElementRef;
  @ViewChild('megamenuColumns') megamenuColumns!: ElementRef;

  @HostListener('window:resize') onResize() {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 992) {
        this.isMobile = false;
        this.categories.nativeElement.style.display = '';
      } else {
        this.isMobile = true;
        this.categories.nativeElement.style.display = 'block';
      }
    }
  }

  @HostListener('window:scroll') onScroll() {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      const scroll = window.scrollY || document.documentElement.scrollTop;
      const gradient = document.getElementById('gradientService') as HTMLElement;
      if (this.megamenu && !this.isMobile) {
        gradient.style.top = scroll > 1 ? `${scroll >= 57 ? 78 : 122 - scroll}px` : '122px';
        this.megamenu.nativeElement.style.top =
          scroll > 1 ? `${scroll >= 57 ? 78 : 122 - scroll}px` : '122px';
      }
    }
  }

  ngOnInit(): void {
    this.getCategoriesService();
    if (typeof window !== 'undefined') {
      this.isMobile = window.innerWidth <= 992;
    }
  }

  getCategoriesService(): void {
    this.categoriesService$ = this.headService.getCategoriesCustomerService().pipe(
      map((res) => res ?? []),
      catchError((error) => {
        console.error(error);
        return of([]);
      })
    );
  }

  closeMegaMenu(): void {
    if (!this.isMobile) {
      if (typeof document !== 'undefined') {
        const linkService = document.getElementById('linkService');
        linkService?.classList.remove('opened');
        document.body.classList.remove('lockScroll');
        const megamenu = document.getElementById('megamenuService');
        megamenu?.classList.remove('showMegamenu');
        const gradient = document.getElementById('gradientService');
        gradient?.classList.remove('showMegamenu');
      }
    }
  }

  hideCategories(): void {
    if (typeof window !== 'undefined') {
      const megamenu = document.getElementById('megamenuService');
      megamenu?.classList.remove('showMegamenu');
    }
  }

  checkIsMegaMenuOnHover(): void {
    setTimeout(() => {
      if (typeof window !== 'undefined') {
        if (window.innerWidth > 992) {
          const megamenuColumns = document.getElementById('categoriesServiceMenu');
          if (!megamenuColumns?.matches(':hover')) {
            // if (!this.megamenuColumns.nativeElement.matches(':hover')) {
            document.body.classList.remove('lockScroll');
            const linkService = document.getElementById('linkService');
            linkService?.classList.remove('opened');
            const megamenu = document.getElementById('megamenuService');
            megamenu?.classList.remove('showMegamenu');
            const gradient = document.getElementById('gradientService');
            gradient?.classList.remove('showMegamenu');
          }
        }
      }
    }, 200);
  }

  closeAll(): void {
    if (typeof document !== 'undefined') {
      this.categories.nativeElement.style.display = 'flex';
      document.body.classList.remove('lockScroll');
      const megamenu = document.getElementById('megamenuService');
      megamenu?.classList.remove('showMegamenu');
      const menu = document.querySelector('#mainMenu.navTracsa .contentLinksNav') as HTMLElement;
      if (menu.classList.contains('opened')) {
        menu.classList.remove('opened');
      }
      menu.style.display = '';
      const menuMobileBtn = document.querySelector('.menuBtnMobile') as HTMLElement;
      if (menuMobileBtn.classList.contains('active')) {
        menuMobileBtn.classList.remove('active');
      }
    }
  }
}
